export var VideoType;
(function (VideoType) {
    VideoType["Error"] = "error";
    VideoType["Vimeo"] = "vimeo";
    VideoType["YouTube"] = "youtube";
})(VideoType || (VideoType = {}));
var convertVideoUrlToEmbedUrl = function (videoUrl) {
    if (!videoUrl) {
        return null;
    }
    var youTubeRegExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\\&v=)([^#\\&\\?]*).*/;
    var youtubeMatch = videoUrl.match(youTubeRegExp);
    var youtubeEmbedUrl = "https://www.youtube.com/embed/";
    if (youtubeMatch && youtubeMatch[2]) {
        return {
            type: VideoType.YouTube,
            url: "" + youtubeEmbedUrl + youtubeMatch[2]
        };
    }
    var vimeoRegExp = /(http|https)?:\/\/(player\.|www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|)(\d+)(?:|\/\?)/;
    var vimeoMatch = videoUrl.match(vimeoRegExp);
    var vimeoEmbedUrl = "https://player.vimeo.com/video/";
    if (vimeoMatch && vimeoMatch[4]) {
        return {
            type: VideoType.Vimeo,
            url: "" + vimeoEmbedUrl + vimeoMatch[4]
        };
    }
    return {
        type: VideoType.Error
    };
};
export default convertVideoUrlToEmbedUrl;
